import { module } from 'modujs';
import gsap from "gsap";
import { ENV } from '../config';

export default class extends module {
    constructor(m) {
        super(m);

        this.covers = this.el.querySelector('.realisation_navigation_covers');
        this.coverDefault = this.el.querySelector('.realisation_navigation_cover.-default');
        this.coverPrev = this.el.querySelector('.realisation_navigation_cover.-prev');
        this.coverNext = this.el.querySelector('.realisation_navigation_cover.-next');

        this.minHeight = null;
        this.multiple = ENV.IS_SM && ENV.IS_TOUCH ? 1 : 1.5;

        this.labels = this.el.querySelector('.realisation_navigation_labels');
        this.labelDefault = this.el.querySelector('.realisation_navigation_label.-default');
        this.labelPrev = this.el.querySelector('.realisation_navigation_label.-prev');
        this.labelNext = this.el.querySelector('.realisation_navigation_label.-next');

        this.buttonPrev = this.el.querySelector('.realisation_navigation_button.-prev');
        this.buttonNext = this.el.querySelector('.realisation_navigation_button.-next');
    }

    init() {

        this.buttonPrev.addEventListener('mouseenter', () => {
            if (this.covers.querySelector('.-active')) {
                this.covers.querySelector('.-active').classList.remove('-active');
            }
            if (this.labels.querySelector('.-active')) {
                this.labels.querySelector('.-active').classList.remove('-active');
            }
            
            this.coverPrev.classList.add('-active');
            this.labelPrev.classList.add('-active');
        });

        this.buttonNext.addEventListener('mouseenter', () => {
            if (this.covers.querySelector('.-active')) {
                this.covers.querySelector('.-active').classList.remove('-active');
            }
            if (this.labels.querySelector('.-active')) {
                this.labels.querySelector('.-active').classList.remove('-active');
            }
            
            this.coverNext.classList.add('-active');
            this.labelNext.classList.add('-active');
        });


        this.buttonPrev.addEventListener('mouseleave', () => {
            this.coverPrev.classList.remove('-active');
            this.labelPrev.classList.remove('-active');

            this.coverDefault.classList.add('-active');
            this.labelDefault.classList.add('-active');
        });

        this.buttonNext.addEventListener('mouseleave', () => {
            this.coverNext.classList.remove('-active');
            this.labelNext.classList.remove('-active');

            this.coverDefault.classList.add('-active');
            this.labelDefault.classList.add('-active');
        });


        this.updateHeight();

        window.addEventListener("resize",() => {
            this.minHeight = 1;
            this.labels.style.minHeight = this.minHeight * this.multiple + 'px';
            this.updateHeight();
        });
    }

    hideTitle(elt) {
        gsap.killTweensOf(this.labelDefault.querySelectorAll('.word'));
        gsap.killTweensOf(elt.querySelectorAll('.word'));
        gsap.to(elt.querySelectorAll('.word'), {
            y: '101%',
            opacity: 0,
            duration: 0.4,
            ease: 'power4.out'
        });
    }

    showTitle(elt) {
        gsap.killTweensOf(elt.querySelectorAll('.word'));
        gsap.fromTo(elt.querySelectorAll('.word'), {
            y: '101%',
            opacity: 0,
        }, {
            y: 0,
            opacity: 1,
            duration: 0.8,
            ease: 'power4.out',
            stagger: 0.05
        });
    }

    updateHeight() {
        if (ENV.IS_SM && ENV.IS_TOUCH) {
            let b = this.labelDefault.getBoundingClientRect();
            this.minHeight = b.height;
        } else {
            this.el.querySelectorAll('.realisation_navigation_label').forEach((elt) => {
                let b = elt.getBoundingClientRect();
                if (this.minHeight == null || this.minHeight < b.height) {
                    this.minHeight = b.height;
                }
            });
        }

        this.labels.style.minHeight = this.minHeight * this.multiple + 'px';
    }
}
